/* ==========================================================================
   Redesign — collection template
   Loaded only when rd_collection (snippets/redesign-active.liquid).

   Filtering happens in place: the whole collection is already in the DOM, so a
   tab or facet click hides cards rather than fetching a page. That is the
   design's behaviour, and it is why the counts can stay honest without a round
   trip.

   TAG MATCHING IS DELIMITED. Every card carries data-rd-tags as
   "||hipp||hipp dutch||stage 1||cow based||", and every probe is wrapped the
   same way, so "hipp" cannot match "hipp dutch" and "stage 1" cannot match
   "stage 10". The Liquid that renders the counts uses the identical rule — if
   one side changes, both have to.

   Facets are ORed within a group and ANDed across groups, which is what a
   shopper means by "Stage 1 or Stage 2, in goat". A tab is a further AND.
   ========================================================================== */
(function () {
  'use strict';

  var grid = document.querySelector('[data-rd-grid]');
  if (!grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('.rd-cgrid__item'));
  var empty = document.querySelector('[data-rd-empty]');
  var countEl = document.querySelector('[data-rd-count]');
  var tabsWrap = document.querySelector('[data-rd-tabs]');
  /* data-rd-FILTERS, not data-rd-drawer. The header's nav drawer owns the
     latter, and this selector runs on a page that has both — so it matched the
     nav drawer instead (it comes first in the document), and the Filters button
     opened the mobile menu. The filters drawer never opened at all, which is
     also why its scrim fade looked missing. Separate namespaces, no overlap. */
  var drawer = document.querySelector('[data-rd-filters]');

  var total = items.length;
  /* False until the first apply() has run. The entrance animation is only
     correct for cards the visitor has not seen; on the initial pass they are
     already painted. See the note in redesign-collection-grid.liquid. */
  var primed = false;
  var activeTab = '';
  var activeNot = '';
  /* group index -> array of selected tags. Groups are the facet wrappers on
     desktop; the drawer repeats the same groups in the same order, so one
     index space covers both. */
  var selected = {};

  function tagsOf(el) { return el.getAttribute('data-rd-tags') || ''; }
  function has(hay, tag) { return hay.indexOf('||' + tag + '||') !== -1; }

  /* A tab can carry several comma-separated tags, matched as OR — the design's
     "Specialty" shelf is Hypoallergenic plus Sensitive. Split once here and in
     the Liquid that renders the counts; the two must agree. */
  function hasAny(hay, csv) {
    var parts = csv.split(',');
    for (var i = 0; i < parts.length; i++) {
      if (has(hay, parts[i].trim())) return true;
    }
    return false;
  }

  /* A tab may also EXCLUDE tags — the design's German shelf is every HiPP
     German product except the hypoallergenic ones. */
  function tabAllows(hay) {
    if (activeTab && !hasAny(hay, activeTab)) return false;
    if (activeNot && hasAny(hay, activeNot)) return false;
    return true;
  }

  function matches(el) {
    var hay = tagsOf(el);
    if (!tabAllows(hay)) return false;
    for (var g in selected) {
      var picks = selected[g];
      if (!picks || !picks.length) continue;
      var any = false;
      for (var i = 0; i < picks.length; i++) {
        if (has(hay, picks[i])) { any = true; break; }
      }
      if (!any) return false;
    }
    return true;
  }

  /* Count for one option, as if that option were the only thing added to the
     current state. Without the "as if", every number outside the active group
     collapses to the current result count and the panel stops being useful. */
  function countFor(group, tag) {
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var hay = tagsOf(items[i]);
      if (!tabAllows(hay)) continue;
      var ok = true;
      for (var g in selected) {
        if (g === group) continue;
        var picks = selected[g];
        if (!picks || !picks.length) continue;
        var any = false;
        for (var j = 0; j < picks.length; j++) {
          if (has(hay, picks[j])) { any = true; break; }
        }
        if (!any) { ok = false; break; }
      }
      if (ok && has(hay, tag)) n++;
    }
    return n;
  }

  function countForTab(tag, not) {
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var hay = tagsOf(items[i]);
      if (tag && !hasAny(hay, tag)) continue;
      if (not && hasAny(hay, not)) continue;
      var ok = true;
      for (var g in selected) {
        var picks = selected[g];
        if (!picks || !picks.length) continue;
        var any = false;
        for (var j = 0; j < picks.length; j++) {
          if (has(hay, picks[j])) { any = true; break; }
        }
        if (!any) { ok = false; break; }
      }
      if (ok) n++;
    }
    return n;
  }

  function groupOf(btn) {
    var panel = btn.closest('.rd-facet__panel') || btn.closest('.rd-cdrawer__opts');
    if (!panel) return '0';
    var siblings = document.querySelectorAll('.rd-facet__panel, .rd-cdrawer__opts');
    /* Desktop panels and drawer groups are rendered in the same order, so the
       index within each list is the same group. */
    var list = panel.classList.contains('rd-facet__panel')
      ? document.querySelectorAll('.rd-facet__panel')
      : document.querySelectorAll('.rd-cdrawer__opts');
    for (var i = 0; i < list.length; i++) if (list[i] === panel) return String(i);
    return '0';
  }

  function syncOptionState() {
    document.querySelectorAll('[data-rd-facet]').forEach(function (btn) {
      var g = groupOf(btn);
      var tag = btn.getAttribute('data-rd-facet');
      var on = (selected[g] || []).indexOf(tag) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var n = btn.querySelector('.rd-facet__n');
      if (n) n.textContent = countFor(g, tag);
    });

    /* A facet button shows a clear affordance only while that group is doing
       something. */
    document.querySelectorAll('[data-rd-facet-reset]').forEach(function (btn) {
      var panel = btn.closest('.rd-facet__panel') || btn.closest('.rd-cdrawer__opts');
      var opt0 = panel && panel.querySelector('[data-rd-facet]');
      var empty = !opt0 || !(selected[groupOf(opt0)] || []).length;
      btn.setAttribute('aria-pressed', empty ? 'true' : 'false');
    });

    document.querySelectorAll('[data-rd-facet-wrap]').forEach(function (wrap, i) {
      var picks = selected[String(i)] || [];
      var clear = wrap.querySelector('[data-rd-facet-clear]');
      if (clear) clear.hidden = picks.length === 0;
      wrap.classList.toggle('is-filtering', picks.length > 0);
    });

    if (tabsWrap) {
      tabsWrap.querySelectorAll('[data-rd-tab]').forEach(function (btn) {
        var n = btn.querySelector('.rd-cgrid__tab-n');
        if (n) n.textContent = countForTab(btn.getAttribute('data-rd-tab') || '', btn.getAttribute('data-rd-not') || '');
      });
    }
  }

  function apply() {
    var shown = 0;
    items.forEach(function (el) {
      var ok = matches(el);
      el.hidden = !ok;
      if (ok) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
    /* The design reads "25 formulas" with nothing filtered and "9 of 25
       formulas" once something is. The noun and the separator are authored in
       Liquid so a translated theme still reads. */
    if (countEl) {
      var noun = countEl.getAttribute('data-rd-noun') || '';
      var sep = countEl.getAttribute('data-rd-of') || ' of ';
      var filtering = !!activeTab || Object.keys(selected).some(function (k) { return (selected[k] || []).length; });
      countEl.textContent = filtering ? (shown + sep + total + ' ' + noun) : (total + ' ' + noun);
    }
    /* Re-trigger the card animation. Re-applying the same animation name to
       the same element does not restart it, so the grid alternates between two
       identical keyframe sets. Skipped on the initial pass: those cards came
       from the server and are already on screen, and animating them there is
       what read as the grid reloading itself a beat after the page settled. */
    if (grid && primed) {
      grid.setAttribute('data-rd-gen', grid.getAttribute('data-rd-gen') === 'a' ? 'b' : 'a');
    }
    syncOptionState();
  }

  /* ------------------------------------------------------------------ tabs */
  function selectTab(btn) {
    if (!btn || !tabsWrap) return;
    activeTab = btn.getAttribute('data-rd-tab') || '';
    activeNot = btn.getAttribute('data-rd-not') || '';
    tabsWrap.querySelectorAll('[data-rd-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    syncNeedCard();
    apply();
  }

  if (tabsWrap) {
    tabsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rd-tab]');
      if (btn) selectTab(btn);
    });
  }

  /* -------------------------------------------------- hydrolysis need card */
  /* The hero card's first two rows are alternate ways into two of the tabs,
     which is what the design makes them. They drive the real tab rather than
     filtering separately, so the chips, the count and the card cannot end up
     telling the visitor different things. Picking the row whose tab is already
     active goes back to All, mirroring the design's toggle. */
  var needRows = [].slice.call(document.querySelectorAll('[data-rd-need-tag]'));

  function tabForTag(tag) {
    if (!tabsWrap) return null;
    var all = [].slice.call(tabsWrap.querySelectorAll('[data-rd-tab]'));
    for (var i = 0; i < all.length; i++) {
      if ((all[i].getAttribute('data-rd-tab') || '') === tag) return all[i];
    }
    return null;
  }

  function syncNeedCard() {
    /* selectTab can fire before this file's later declarations have run. */
    if (!needRows) return;
    needRows.forEach(function (row) {
      var on = (row.getAttribute('data-rd-need-tag') || '') === activeTab && activeTab !== '';
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  if (needRows.length && tabsWrap) {
    needRows.forEach(function (row) {
      row.addEventListener('click', function () {
        var tag = row.getAttribute('data-rd-need-tag') || '';
        var already = tag === activeTab;
        var target = tabForTag(already ? '' : tag);
        if (target) selectTab(target);
      });
    });
    syncNeedCard();
  }

  /* ---------------------------------------------------------------- facets */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-rd-facet]');
    if (opt) {
      var g = groupOf(opt);
      var tag = opt.getAttribute('data-rd-facet');
      var picks = selected[g] || (selected[g] = []);
      var at = picks.indexOf(tag);
      if (at === -1) picks.push(tag); else picks.splice(at, 1);
      apply();
      return;
    }

    var reset = e.target.closest('[data-rd-facet-reset]');
    if (reset) {
      var panel = reset.closest('.rd-facet__panel') || reset.closest('.rd-cdrawer__opts');
      var opt0 = panel && panel.querySelector('[data-rd-facet]');
      if (opt0) { selected[groupOf(opt0)] = []; apply(); }
      return;
    }

    /* The clear pip sits inside the dropdown button, so it has to swallow the
       click before the toggle sees it. */
    var clear = e.target.closest('[data-rd-facet-clear]');
    if (clear) {
      e.preventDefault();
      e.stopPropagation();
      var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-rd-facet-wrap]'));
      var idx = wraps.indexOf(clear.closest('[data-rd-facet-wrap]'));
      if (idx > -1) { selected[String(idx)] = []; apply(); }
      return;
    }

    var toggle = e.target.closest('.rd-facet__btn');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      var open = toggle.getAttribute('aria-expanded') === 'true';
      closeAllFacets();
      if (!open && panel) {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
      return;
    }

    if (!e.target.closest('.rd-facet__panel')) closeAllFacets();
  });

  function closeAllFacets() {
    document.querySelectorAll('.rd-facet__btn[aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllFacets();
    if (drawer && !drawer.hidden) closeDrawer();
  });

  /* ---------------------------------------------------------------- drawer */
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    /* Reopened mid-close: drop the closing state so its pending finish does
       not hide the drawer we have just reopened. */
    drawer.classList.remove('is-closing');
    drawer.hidden = false;
    document.body.classList.add('rd-modal-open');
    /* is-open goes on in the SAME tick as unhiding, the way the cart drawer
       does it. The forced reflow that used to sit here was needed by the old
       transition-based version, and with animations it actively hurt: it
       painted one frame with the drawer visible and the class not yet applied,
       so the scrim showed at full strength before the fade-in began. */
    drawer.classList.add('is-open');
    var close = drawer.querySelector('.rd-cdrawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    if (drawer.hidden || drawer.classList.contains('is-closing')) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');

    /* Animations, not transitions, so this matches the cart drawer exactly —
       it is the overlay that reads correctly and the other two now follow it.
       [hidden] waits for them: applying it straight away removed the panel and
       scrim before either could play.

       animationend BUBBLES, so the target check matters — without it any child
       animation finishing inside the panel would end the close early and cut
       the scrim's fade off partway, which is what made the exit look abrupt.
       Both the panel and the scrim have to finish, and the timer behind them
       covers reduced motion and background tabs. */
    var panel = drawer.querySelector('.rd-cdrawer__panel');
    var scrim = drawer.querySelector('.rd-cdrawer__scrim');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var fired = false;
    function done() {
      if (fired) return;
      fired = true;
      if (panel) panel.removeEventListener('animationend', onEnd);
      if (scrim) scrim.removeEventListener('animationend', onEnd);
      drawer.classList.remove('is-closing');
      /* The scroll lock comes off with the drawer, not ahead of it — released
         at the top of the close it reflowed the page under a still-moving
         panel. Matches the cart and the popup. */
      document.body.classList.remove('rd-modal-open');
      /* Reopened mid-close — leave it alone. */
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }
    function onEnd(e) {
      if (e.target !== e.currentTarget) return;
      if (--left <= 0) done();
    }

    if (!panel || reduced) {
      done();
    } else {
      var left = scrim ? 2 : 1;
      panel.addEventListener('animationend', onEnd);
      if (scrim) scrim.addEventListener('animationend', onEnd);
      setTimeout(done, 500);
    }

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rd-filters-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-rd-filters-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-rd-clear]')) {
      selected = {};
      activeTab = '';
      activeNot = '';
      if (tabsWrap) {
        tabsWrap.querySelectorAll('[data-rd-tab]').forEach(function (b, i) {
          b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        });
      }
      apply();
    }
  });

  /* ------------------------------------------------- chip row edge fade */
  /* The tab row scrolls horizontally on mobile. The fade on its right edge is
     the only cue that there is more, so it has to disappear at the end rather
     than sit there implying content that is not here. */
  var chipRow = document.querySelector('.rd-cgrid__tabs');
  var fadeEnd = document.querySelector('[data-rd-chip-fade]');
  var fadeStart = document.querySelector('[data-rd-chip-fade-start]');
  if (chipRow && (fadeEnd || fadeStart)) {
    var updateFade = function () {
      var left = chipRow.scrollLeft;
      var more = chipRow.scrollWidth - chipRow.clientWidth - left;
      /* The right fade asks the ordinary question — is there more row past
         this edge. The left one only appears at the far end of the row, once
         the Filters button is in view.

         Not simply "scrolled away from the start": the chips carry
         scroll-snap-align: start, so at every intermediate position a pill is
         snapped flush to the left edge, and fading across it reads as a
         rendering fault rather than as more content. At the end of the row
         there is nothing left to snap to, so the fade has something to be
         about. Both keep the same 8px tolerance so neither lingers on a
         sub-pixel remainder. */
      var atEnd = more <= 8;
      if (fadeEnd) fadeEnd.style.opacity = atEnd ? '0' : '1';
      if (fadeStart) fadeStart.style.opacity = (atEnd && left > 8) ? '1' : '0';
    };
    chipRow.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    updateFade();
  }

  /* ------------------------------------------------- wide-table expander */
  /* The design puts an "Expand table to full width" toggle above the
     ingredient matrix: the hub's reading column is ~810px and the matrix is
     fourteen columns wide, so inside the column it is mostly horizontal
     scrolling. Expanded, it breaks out to the page gutters.

     The button is injected rather than authored, because the copy it sits
     above is ported verbatim and frozen — and because that means every wide
     table on every collection gets one without touching any of them.

     Only tables that actually overflow get a toggle. A table that fits needs
     no escape hatch, and offering one that does nothing is worse than none. */
  (function () {
    var GUTTER = 40;
    /* Below this much extra width the toggle is not worth offering. */
    var MIN_GAIN = 60;

    /* Tells the sticky-header module its cached column widths are stale. */
    function notifyResize() {
      window.dispatchEvent(new CustomEvent('rd:table-resize'));
    }

    function roomFor(box) {
      return document.documentElement.clientWidth - GUTTER * 2 - box.clientWidth;
    }

    document.querySelectorAll('.rd-hub__scroll').forEach(function (box) {
      var table = box.querySelector('table');
      if (!table) return;
      if (table.scrollWidth <= box.clientWidth + 4) return;
      /* The mobile design has no expand toggle at all, and the arithmetic says
         why: on a phone the box already spans the content column, so a 40px
         gutter each side made the "expanded" box NARROWER than the collapsed
         one. Only offer it where it genuinely buys width. */
      if (roomFor(box) < MIN_GAIN) return;

      var bar = document.createElement('div');
      bar.className = 'rd-hub__expand-bar';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rd-hub__expand';
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round" aria-hidden="true"><path d="M9 3H3v6M15 3h6v6M9 21H3v-6M15 21h6v-6"/></svg>' +
        '<span></span>';
      var label = btn.querySelector('span');
      bar.appendChild(btn);
      box.parentNode.insertBefore(bar, box);

      var wide = false;

      function collapse() {
        wide = false;
        box.classList.remove('is-wide');
        box.style.width = '';
        box.style.marginLeft = '';
        label.textContent = 'Expand table to full width';
        btn.setAttribute('aria-expanded', 'false');
        notifyResize();
      }

      function expand() {
        wide = true;
        box.classList.add('is-wide');
        /* Measure while collapsed: how far the box sits from the page edge is
           what it has to be pulled back by. Set width first so the shift is
           computed against the collapsed position, not the expanded one. */
        box.style.width = '';
        box.style.marginLeft = '';
        var left = box.getBoundingClientRect().left;
        var vw = document.documentElement.clientWidth;
        /* Never narrower than the collapsed box, whatever the viewport does. */
        box.style.width = Math.max(box.clientWidth, vw - GUTTER * 2) + 'px';
        box.style.marginLeft = '-' + Math.max(0, left - GUTTER) + 'px';
        label.textContent = 'Collapse table';
        btn.setAttribute('aria-expanded', 'true');
        notifyResize();
      }

      collapse();
      btn.addEventListener('click', function () { wide ? collapse() : expand(); });

      /* A resize while expanded leaves the pull-back measured against the old
         viewport, so re-measure rather than leaving it wrong. */
      window.addEventListener('resize', function () {
        /* Resized down to where expanding no longer makes sense — put it back
           and take the toggle away, which is what a phone should see. */
        if (roomFor(box) < MIN_GAIN) {
          if (wide) collapse();
          bar.hidden = true;
          return;
        }
        bar.hidden = false;
        if (!wide) return;
        /* Re-measure without animating: the box is already open, so easing it
           shut and back open on every resize tick would be noise. */
        var t = box.style.transition;
        box.style.transition = 'none';
        collapse();
        expand();
        void box.offsetWidth;
        box.style.transition = t;
      });
    });
  })();

  apply();
  primed = true;
})();

  /* ------------------------------------------------ sticky table headers */
  /* Ported from the design's own implementation. TWO modes, picked per table
     per frame — there is no third:

       1. Table FITS    -> overflow:clip on the wrapper. `clip` is not a scroll
                           container, so the th cells' own CSS sticky takes over
                           and pins to the viewport. No JS in the scroll path,
                           so nothing can lag.
       2. Table SCROLLS -> a position:fixed CLONE of the header, overlaid the
                           moment the real one passes under the site header.
                           Fixed needs no per-frame vertical update, so the
                           compositor owns it and it cannot drift; only
                           horizontal panning syncs it, off the wrapper's own
                           scroll event.

     THE DESIGN DOES NOT TRANSLATE THEADS. Its desktop file contains a rAF loop
     that does, and I ported it — but its mobile file opens the same loop with
     an unconditional `continue` and the comment "sticky theads are handled by
     the fixed clones in syncClone", and its syncClone runs every .rd-scroll
     through syncOne rather than the matrix alone. The translate path is dead
     code in the shipped design. It is also why the headers moved: a rAF loop
     reading scroll position and writing a transform is always a frame behind,
     which is exactly the jitter, and exactly why the matrix never showed it.

     Mode is re-evaluated when something that can change it happens — load,
     fonts arriving, a resize, an expand toggle, or the table itself changing
     size (ResizeObserver, which also catches lazy images landing inside it).
     It WAS re-evaluated every animation frame: two layout reads per table per
     frame, forever, which Lighthouse booked as 3.9s of main-thread time on
     /collections/hipp-baby-formula and kept the page from ever going idle.
     Scroll only positions the clones (syncAll), which is all scroll can change. */
  (function () {
    var boxes = [].slice.call(document.querySelectorAll('.rd-hub__scroll'));
    if (!boxes.length) return;

    function headerH() {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--rd-header-h');
      return parseFloat(v) || 76;
    }

    /* Two of the four tables carry their header as the first <tr> of <th> in
       the body rather than in a <thead> — the markup is ported and frozen, so
       promote it here. Moving the row changes no text and no heading. */
    function headOf(box) {
      var table = box.querySelector('table');
      if (!table) return null;
      var thead = table.querySelector('thead');
      if (thead) return thead;
      var first = table.rows[0];
      if (!first || !first.cells.length || first.cells[0].tagName !== 'TH') return null;
      thead = document.createElement('thead');
      table.insertBefore(thead, table.firstChild);
      thead.appendChild(first);
      return thead;
    }

    function dropClone(box) {
      if (!box.__clone) return;
      box.__clone.box.remove();
      box.__clone = null;
    }

    function syncOne(box, top) {
      var table = box.querySelector('table');
      var thead = box.__thead;
      if (!table || !thead) return;

      /* Every measurement first. Reading layout back after writing to it forces
         a synchronous reflow, and in a per-frame loop that is the difference
         between smooth and not. */
      var r = box.getBoundingClientRect();
      var hh = thead.offsetHeight;
      var show = r.top < top && r.bottom > top + hh;
      var tableW = table.getBoundingClientRect().width;
      var head0 = thead.querySelector('th');
      var head0W = head0 ? head0.getBoundingClientRect().width : 0;
      var clientW = box.clientWidth;
      var left = r.left + box.clientLeft;
      var scrollLeft = box.scrollLeft;

      if (!show) { dropClone(box); return; }

      if (!box.__clone) {
        /* THE CLONE CARRIES THE CLASSES. The design styles every th inline, so
           its cloneNode brings the appearance with it. This theme styles by
           class, and a clone parented to <body> matches none of those
           selectors — without them it loses `color: var(--rd-cream)` and draws
           dark ink on the forest background, i.e. a blank green slab. */
        var cbox = document.createElement('div');
        cbox.className = 'rd-page rd-thead-clone';
        cbox.style.cssText = 'position:fixed;overflow:hidden;z-index:40;pointer-events:none;' +
          'box-shadow:0 10px 18px -12px rgba(20,50,60,.35);background:#17402c';

        var t2 = document.createElement('table');
        t2.className = table.className;
        t2.style.cssText = 'border-collapse:collapse;table-layout:fixed;background:#17402c;';

        var th2 = thead.cloneNode(true);
        var src = thead.querySelectorAll('th');
        var dst = th2.querySelectorAll('th');
        for (var i = 0; i < src.length; i++) {
          /* Rect widths are border-box and a th defaults to content-box, so pin
             the sizing or every column drifts right by its own padding and the
             labels sit over the wrong columns. */
          dst[i].style.boxSizing = 'border-box';
          dst[i].style.width = src[i].getBoundingClientRect().width + 'px';
          dst[i].style.position = 'static';
        }
        t2.appendChild(th2);
        cbox.appendChild(t2);

        var pin = null;
        if (src.length && getComputedStyle(src[0]).position === 'sticky' &&
            getComputedStyle(src[0]).left === '0px') {
          /* The real table freezes its first column, so the clone freezes its
             first header cell to match. Width is explicit because .rd-hub__table
             also says width:100%, which would stretch this single-cell table
             across the whole header and hide every label behind it. */
          pin = document.createElement('table');
          pin.className = table.className;
          pin.style.cssText = t2.style.cssText + ';position:absolute;left:0;top:0';
          pin.style.minWidth = '0';
          var tr = document.createElement('tr');
          var thp = src[0].cloneNode(true);
          thp.style.boxSizing = 'border-box';
          thp.style.width = src[0].getBoundingClientRect().width + 'px';
          thp.style.height = hh + 'px';
          thp.style.position = 'static';
          tr.appendChild(thp);
          pin.appendChild(tr);
          cbox.appendChild(pin);
        }
        document.body.appendChild(cbox);
        box.__clone = { box: cbox, t2: t2, pin: pin, pinCell: pin ? pin.querySelector('th') : null };
      }

      /* Writes only, each guarded on its last value, so a frame where nothing
         moved touches no styles at all. */
      var c = box.__clone;
      if (c.__top !== top) { c.box.style.top = top + 'px'; c.__top = top; }
      if (c.__left !== left) { c.box.style.left = left + 'px'; c.__left = left; }
      if (c.__boxW !== clientW) { c.box.style.width = clientW + 'px'; c.__boxW = clientW; }
      if (c.__tW !== tableW) { c.t2.style.width = tableW + 'px'; c.__tW = tableW; }
      if (c.__sx !== scrollLeft) {
        c.t2.style.transform = 'translateX(' + (-scrollLeft) + 'px)';
        c.__sx = scrollLeft;
      }
      if (c.pin && c.__pinW !== head0W) {
        c.pin.style.width = head0W + 'px';
        if (c.pinCell) c.pinCell.style.width = head0W + 'px';
        c.__pinW = head0W;
      }
    }

    function syncAll() {
      var top = headerH();
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].__mode === 'js') syncOne(boxes[i], top);
      }
    }

    function tick() {
      var top = headerH();

      /* Read pass: decide each table's mode before touching any styles. */
      var frame = [];
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        var th = b.__thead || (b.__thead = headOf(b));
        if (!th) continue;
        frame.push({ box: b, thead: th, fits: b.scrollWidth <= b.clientWidth + 1 });
      }

      /* Write pass: apply the mode. */
      for (var j = 0; j < frame.length; j++) {
        var box = frame[j].box;
        var thead = frame[j].thead;
        if (frame[j].fits) {
          if (box.__mode !== 'css') {
            box.__mode = 'css';
            box.style.overflow = 'clip';
            /* Tells the stylesheet this header pins to the viewport, not to a
               scroll box, so it needs to clear the site header. */
            box.classList.add('is-fit');
            thead.style.transform = 'none';
            thead.style.position = '';
            thead.style.zIndex = '';
            thead.style.boxShadow = 'none';
            dropClone(box);
          }
        } else if (box.__mode !== 'js') {
          box.__mode = 'js';
          box.style.overflow = '';
          box.style.overflowX = 'auto';
          box.classList.remove('is-fit');
        }
      }

      syncAll();
    }

    /* One tick per frame at most, however many triggers fire together. */
    var tickPending = false;
    function scheduleTick() {
      if (tickPending) return;
      tickPending = true;
      requestAnimationFrame(function () { tickPending = false; tick(); });
    }

    scheduleTick();
    window.addEventListener('load', scheduleTick);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleTick);
    window.addEventListener('resize', scheduleTick, { passive: true });
    window.addEventListener('orientationchange', scheduleTick);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(scheduleTick);
      boxes.forEach(function (b) {
        ro.observe(b);
        var t = b.querySelector('table');
        if (t) ro.observe(t);
      });
    }
    window.addEventListener('scroll', syncAll, { passive: true });

    /* Each wrapper pans its own clone horizontally. */
    boxes.forEach(function (b) {
      b.addEventListener('scroll', function () {
        if (b.__mode === 'js') syncOne(b, headerH());
      }, { passive: true });
    });

    /* The expand toggle re-lays every column, so the clone's pinned widths go
       stale the moment it fires. Drop and rebuild once the .35s width
       transition has settled; 400ms is the design's own number. */
    window.addEventListener('rd:table-resize', function () {
      boxes.forEach(dropClone);
      setTimeout(scheduleTick, 400);
    });
  })();

/* ------------------------------------------------- hub contents: scroll spy

   Sam, 3 Sep: the recall tracker highlights which section you are in as you
   scroll its left-hand contents, and the collection hubs were missing it.

   IT DOES NOT USE AN INTERSECTIONOBSERVER, and that is the whole lesson here.
   The recall tracker's version picks the topmost INTERSECTING target, which is
   safe there because it builds its own contents from h2/h3 headings — small,
   non-nesting elements. The hub's anchors come from section blocks and point
   at whatever the copy wraps: on /collections/hipp-baby-formula the first is a
   div 11,954px tall that CONTAINS the other six. It is therefore always
   intersecting and always topmost, so it stayed highlighted the whole way down
   the page. Measured, after shipping the observer version and watching it
   stick.

   Position beats intersection: the current section is the last target whose
   top has passed a reading line just under the sticky sidebar. That is
   indifferent to how big a target is or whether one nests inside another, and
   it is the same rule the pillar guides already use.

   The links are read, never built — the hub's contents come from section
   blocks (anchor + label), so no heading text is touched. This only adds an
   `is-current` class. No-ops on a page with no hub, with fewer than two
   resolvable anchors, or where an anchor's target no longer exists. */
(function () {
  var nav = document.querySelector('.rd-hub__toc');
  if (!nav) return;

  var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
  if (links.length < 2) return;

  var pairs = [];
  links.forEach(function (a) {
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = id && document.getElementById(id);
    if (el) pairs.push({ link: a, el: el });
  });
  if (pairs.length < 2) return;

  /* Just below .rd-hub__side { top: 104px }, so a section becomes current as
     it clears the sidebar's own top edge. */
  var LINE = 116;

  /* Anchor jumps landed each target at y=0, i.e. underneath the 76px sticky
     header, so the section you asked for was hidden behind it and the spy went
     on re-picking while the smooth scroll was still running — which is what
     made a click look like it went to the wrong place and then highlighted the
     wrong row. The offset has to sit BELOW the reading line or the target
     arrives past it and the previous section wins. */
  var OFFSET = 96;
  for (var k = 0; k < pairs.length; k++) pairs[k].el.style.scrollMarginTop = OFFSET + 'px';

  /* And the clicked link owns the highlight until the reader scrolls again.

     NOT a timer. The hubs lazy-load their imagery, so the content above a
     target can still be growing when the smooth scroll ends — measured 80px of
     reflow on the HiPP hub, which left the target sitting at 176 against a
     116px reading line, so the section above it won and the click looked like
     it had gone somewhere else. Releasing on the reader's next scroll gesture
     instead is immune to that: whatever the page does while it settles, the
     row you clicked stays lit until you move. */
  var locked = false;
  function release() { locked = false; }
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, release, { passive: true });
  });
  for (var m = 0; m < pairs.length; m++) {
    (function (pair) {
      pair.link.addEventListener('click', function () {
        locked = true;
        for (var n = 0; n < pairs.length; n++) {
          pairs[n].link.classList.toggle('is-current', pairs[n] === pair);
        }
      });
    })(pairs[m]);
  }
  var raf = null;

  function pick() {
    raf = null;
    var best = null, bestTop = -Infinity;
    if (locked) return;
    for (var i = 0; i < pairs.length; i++) {
      var top = pairs[i].el.getBoundingClientRect().top;
      /* The LOWEST top that is still above the line — order-independent, so a
         wrapper that starts far above cannot outrank the heading you are on. */
      if (top <= LINE && top > bestTop) { bestTop = top; best = pairs[i]; }
    }
    for (var j = 0; j < pairs.length; j++) {
      pairs[j].link.classList.toggle('is-current', best !== null && pairs[j] === best);
    }
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(pick); }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  pick();
})();
